
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import CustomCursor from "@/components/CustomCursor";
import GrainOverlay from "@/components/GrainOverlay";
import Navigation from "@/components/sections/Navigation";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import AboutIntro from "@/components/sections/AboutIntro";
import Portfolio from "@/components/sections/Portfolio";
import Services from "@/components/sections/Services";
import Contact from "@/components/sections/Contact";

export default function App() {
  return (
    <div className="App relative">
      <SmoothScroll>
        <CustomCursor />
        <GrainOverlay />
        <Navigation />

        <main>
          <Hero />
          <Stats />
          <AboutIntro />
          <Services />
          <Portfolio />
          <Contact />
        </main>
      </SmoothScroll>

    </div>
  );
}
